import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}

const TILES = [
  {
    icon: 'fa-screwdriver-wrench',
    title: 'Solutions Development',
    desc: 'Custom software and product engineering built to your exact specifications, from concept to deployment.',
    delay: '0',
  },
  {
    icon: 'fa-shield-halved',
    title: 'Technical Consultancy',
    desc: 'Expert guidance on security, infrastructure, and system architecture to keep you ahead of emerging threats.',
    delay: '200',
  },
  {
    icon: 'fa-people-group',
    title: 'Training',
    desc: 'Hands-on programmes to upskill your team on security practices, tools, and operational resilience.',
    delay: '400',
  },
];

const FeaturesTiles = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {

  const outerClasses = classNames(
    'features-tiles section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-tiles-inner section-inner pt-0',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  return (
    <section {...props} className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <div className="section-header center-content">
            <div className="container-xs">
              <h2 className="mt-0 mb-16" style={{textAlign:'center'}}>
                <div>Disruptive Innovation<span style={{color:'#f83800'}}>.</span></div>
                <div>Secure Implementation<span style={{color:'#f83800'}}>.</span></div>
              </h2>
              <p className="m-0" style={{fontSize:'14px', color:'#9CA9B3'}}>Security-first solutions that give you a competitive edge in the connected world.</p>
            </div>
          </div>
          <div className="service-grid" style={{
            display: 'grid',
            gap: '1px',
            maxWidth: '900px',
            margin: '0 auto',
            background: 'rgba(255,255,255,0.06)',
            borderRadius: '8px',
            overflow: 'hidden',
          }}>
            {TILES.map((tile, i) => (
              <div
                key={i}
                className="reveal-from-bottom"
                data-reveal-delay={tile.delay}
                style={{
                  background: '#151719',
                  padding: '32px 24px',
                  textAlign: 'center',
                  cursor: 'default',
                  transition: 'background 0.3s',
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.background = 'rgba(248,56,0,0.04)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.background = '#151719';
                }}
              >
                <i className={`fa ${tile.icon}`} style={{
                  color: '#f83800',
                  fontSize: '22px',
                  marginBottom: '16px',
                  display: 'block',
                }}></i>
                <h4 className="mt-0 mb-8" style={{ fontSize: '15px', fontWeight: 600, letterSpacing: '0.5px' }}>
                  {tile.title}
                </h4>
                <p className="m-0" style={{ fontSize: '13px', color: '#6B7A85', lineHeight: 1.6 }}>
                  {tile.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <style>{`
        .service-grid {
          grid-template-columns: repeat(3, 1fr);
        }
        @media (max-width: 768px) {
          .service-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
}

FeaturesTiles.propTypes = propTypes;
FeaturesTiles.defaultProps = defaultProps;

export default FeaturesTiles;
